import { loggerFactory } from '@vestigas/logger';
import { Config } from '~/Config';

type Environment = 'production' | 'development';

export const log = loggerFactory({
  environment: Config.environment as Environment,
});
